import { Alert, AlertProps, AlertTitle, Stack } from "@mui/material";
import React from "react";

import { IErrorInterface } from "../../generated/types";
import { CombinedErrorMessages, ICombinedErrorMessagesProps, ITypedErrorInterface } from "./CombinedErrorMessages";

export interface ICombinedErrorAlertProps<TGqlError extends ITypedErrorInterface>
    extends ICombinedErrorMessagesProps<TGqlError> {
    title: string;
    alertProps?: Omit<AlertProps, "children">;
}

export function CombinedErrorAlert<TGqlError extends ITypedErrorInterface = IErrorInterface>({
    title,
    alertProps,
    children,
    ...messageProps
}: React.PropsWithChildren<ICombinedErrorAlertProps<TGqlError>>): React.ReactElement | null {
    if (!ICombinedErrorMessagesProps.isError(messageProps)) {
        return null;
    }

    return (
        <Alert severity="error" {...alertProps}>
            <AlertTitle>{title}</AlertTitle>
            <Stack spacing={1}>
                <CombinedErrorMessages {...messageProps} />
                {children}
            </Stack>
        </Alert>
    );
}
